import React, { useEffect, useRef, useState } from "react";
import { Table, Input } from "antd";
import { Drawer, Select } from "antd";
import CardDiv from "modules/common/card-div/CardDiv";
import { useUserInfo, useSSOTFilterData, useSSOTFilterApply } from "./store";
import { Button, Modal } from "react-bootstrap";
import moment from "moment";
import { get, isEmpty } from "lodash";
import ReactDatePicker from "react-datepicker";
import { currentUser, getFullName, isDownloadDisabled, roles, ROLES_NAME } from "modules/utilities/utility";
import SSOTFilter from "./SSOTFilter";
import Papa from "papaparse";
import {
  Process,
  locationFilters,
  Teams,
  designationFilter,
  AGENT_LANGUAGES,
  MUTATION_FLAGS,
} from "../../config";
import secureLocalStorage from "react-secure-storage";

const SSOT = () => {
  const { fetchEditSSOT } = useUserInfo();
  const { newFiltersData, fetchSSOTFilters } = useSSOTFilterData();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [queryParam, setQueryParam] = useState({
    pageSize: pageSize,
    pageNumber: currentPage,
    call_provider: [],
    current_status: [],
    desgination: [],
    first_name: undefined,
    house: [],
    location: [],
    process: [],
    reporting_manager: [],
    shift: [],
    team: [],
    week_off: [],
  });

  const { fetchSSOTFiltersApply, newFiltersApplyData, getQaAgentsList, qaAgentsResponse, qaAgentsLoading } = useSSOTFilterApply();
  const [ssotUserData, setSsotUserData] = useState([]);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [modalShow, setModalShow] = React.useState(false);
  const uniqueLocationFilters = [...new Set(locationFilters)];
  const [selectedUser, setSelectedUser] = useState(null);
  const { fetchUserData, userData } = useUserInfo();

  const initialFormData = {
    house: "",
    location: "",
    process: "",
    callProvider: "",
    team: "",
    reportingManager: "",
    weekOff: "",
    desgination: "",
    shift: "",
    doj: "",
    currentStatus: "",
    employeeId: "",
    preferredLanguage: "", // New field for Language
  };

  const [formData, setFormData] = useState(initialFormData);
  const initialFormDataRef = useRef(initialFormData);

  const [date, setDate] = useState(null);
  const [visible, setVisible] = useState(false);
  const [triggerFetch, setTriggerFetch] = useState(true);

  const [myQa, setMyQa] = useState({
    id: null,
    first_name: null,
    last_name: null,
  });

  const [selectedQa, setSelectedQa] = useState({
    id: null,
    flag: null,
  });

  function clearQaStates() {
    setSelectedQa({
      id: null,
      flag: null,
    });
    setMyQa({
      id: null,
      first_name: null,
      last_name: null,
    });
  }

  const buildQueryString = (data) => {
    const params = new URLSearchParams();
    for (const key in data) {
      if (Array.isArray(data[key])) {
        params.append(
          key,
          `[${data[key].map((value) => `'${value}'`).join(",")}]`
        );
      } else if (data[key] !== undefined && data[key] !== "") {
        params.append(key, data[key]);
      }
    }
    return `?${params.toString()}`;
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormData((prev) => ({
      ...prev,
      [name]: name !== 'employeeId' && isEmpty(value) ? 'NA' : value,
    }));
  };

  const handleLanguageChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      preferredLanguage: value, // Update the language in formData
    }));
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "first_name",
      key: "first_name",
      fixed: "left",
    },
    {
      title: "Employee ID",
      dataIndex: "employee_id",
      key: "employee_id",
      fixed: "left",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Source",
      dataIndex: "house",
      key: "house",
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
    },
    {
      title: "Call Provider",
      dataIndex: "call_provider",
      key: "call_provider",
    },
    {
      title: "Process",
      dataIndex: "process",
      key: "process",
    },
    {
      title: "Team",
      dataIndex: "team",
      key: "team",
    },
    {
      title: "QA",
      dataIndex: "qa_user",
      key: "qa_user",
      render: (value, record) => getFullName(value) || '-',
    },
    {
      title: "Reporting Manager",
      dataIndex: "reporting_manager",
      key: "reporting_manager",
      render: (value, record) => {
        const searchResult = userData?.find((user) => user.user.id === value);
        return searchResult?.user?.first_name || null;
      },
    },
    {
      title: "Designation",
      dataIndex: "desgination",
      key: "desgination",
    },
    {
      title: "DOJ",
      dataIndex: "doj",
      key: "doj",
      render: (text, record) => (
        <span>
          {record.doj &&
            moment(record.doj).utcOffset("+05:30").format("DD-MM-YYYY")}
        </span>
      ),
    },
    {
      title: "Shift",
      dataIndex: "shift",
      key: "shift",
    },
    {
      title: "Week Offs",
      dataIndex: "week_off",
      key: "week_off",
    },
    {
      title: "Current Status",
      dataIndex: "deactivated",
      key: "deactivated",
      render: (text, record) => {
        return record.deactivated ? "Relieved" : "Working";
      },
    },
    {
      title: "Language",
      dataIndex: "preferred_language",
      key: "preferred_language",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Button onClick={() => handleAction(record)}>Edit</Button>
      ),
      fixed: "right",
    },
  ];

  const handleAction = (record) => {
    setModalShow(true);
    const formData = {
      house: get(record, "house", ""),
      location: get(record, "location", ""),
      process: get(record, "process", ""),
      callProvider: get(record, "call_provider", ""),
      team: get(record, "team", ""),
      reportingManager: get(record, "reporting_manager", ""),
      weekOff: get(record, "week_off", ""),
      desgination: get(record, "desgination", ""),
      shift: get(record, "shift", ""),
      doj: get(record, "doj", ""),
      currentStatus: get(record, "current_status", ""),
      employeeId: get(record, "employee_id", ""),
      preferredLanguage: get(record, "preferred_language", ""), // Set language if available
    };
    setSelectedUser(record);
    setFormData(formData);
    initialFormDataRef.current = formData;

    if (record?.qa_user) {
      setMyQa(get(record, ['qa_user']))
    }
  };

  const filterAndTransformParams = (params) => {
    return Object.fromEntries(
      Object.entries(params)
        .filter(([key, value]) =>
          Array.isArray(value) ? value.length > 0 : value
        )
        .map(([key, value]) => [
          key,
          Array.isArray(value) ? JSON.stringify(value) : value,
        ])
    );
  };

  useEffect(() => {
    if (triggerFetch) {
      const updatedFilters = filterAndTransformParams(queryParam);
      const queryString = buildQueryString(updatedFilters);

      fetchSSOTFiltersApply(queryString);
      if (
        newFiltersApplyData.result &&
        newFiltersApplyData.result.length !== 0
      ) {
        setSsotUserData(newFiltersApplyData.result);
      }
    }
    setTriggerFetch(false);
  }, [triggerFetch, queryParam]);

  useEffect(() => {
    fetchSSOTFilters();
  }, []);

  useEffect(() => {
    if (newFiltersApplyData.result && newFiltersApplyData.result.length !== 0) {
      setSsotUserData(newFiltersApplyData.result);
    }
  }, [newFiltersApplyData.result, ssotUserData]);

  const handleTableChange = (pagination) => {
    const updatedPagination = {
      ...queryParam,
      pageSize: pagination.pageSize,
      pageNumber: pagination.current,
    };
    setPageSize(pagination.pageSize);
    setCurrentPage(pagination.current);
    setQueryParam(updatedPagination);
    const updatedFilters = filterAndTransformParams(updatedPagination);
    setQueryParam(updatedFilters);
    setTriggerFetch(true);
  };

  const downloadCSV = () => {
    const filteredData = ssotUserData.filter((record) => {
      if (!record.house || record.house.trim() === "") {
        return false;
      }
      return true;
    });

    const data = filteredData.map((user) => {
      const reportingManager = userData.find(
        (rm) => rm.user.id === user.reporting_manager
      );
      const dojIST = new Date(user?.doj);
      dojIST.setHours(dojIST.getHours() + 5);
      dojIST.setMinutes(dojIST.getMinutes() + 30);

      return {
        Name: user?.first_name,
        House: user?.house,
        Location: user?.location,
        Process: user?.process,
        CallProvider: user?.call_provider,
        Team: user?.team,
        ReportingManager: reportingManager
          ? reportingManager?.user?.first_name
          : "Unknown",
        WeekOff: user?.week_off,
        Designation: user?.desgination,
        Shift: user?.shift,
        DOJ: dojIST,
        CurrentStatus: user?.deactivated ? "Relived" : "Working",
        EmployeeID: user.employee_id,
      };
    });

    const csv = Papa.unparse(data);

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `user_data_${moment().format("YYYY-MM-DD")}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (ssotUserData && filteredInfo) {
      const filteredCount = ssotUserData.filter((record) => {
        for (let key in filteredInfo) {
          if (filteredInfo[key]?.toString() && record[key]?.toString()) {
            const recordValue =
              typeof record[key] === "string"
                ? record[key].toLowerCase()
                : record[key];
            const filterValue =
              typeof filteredInfo[key] === "string"
                ? filteredInfo[key].toLowerCase()
                : filteredInfo[key];
            if (key === "reporting_manager") {
              const reportingManager = userData.find(
                (user) => user.user.id === record.reporting_manager
              );
              if (
                reportingManager &&
                !reportingManager?.user?.first_name
                  .toLowerCase()
                  .includes(filterValue.toString().toLowerCase())
              ) {
                return false;
              }
            } else if (key === "deactivated") {
              if (recordValue.toString() !== filterValue.toString()) {
                return false;
              }
            } else if (Array.isArray(filterValue)) {
              if (
                !filterValue.some((fValue) =>
                  typeof fValue === "boolean"
                    ? fValue.toString() === recordValue.toString()
                    : recordValue.includes(fValue.toLowerCase())
                )
              ) {
                return false;
              }
            } else {
              if (recordValue !== filterValue) {
                return false;
              }
            }
          } else if (filteredInfo[key] && !record[key]) {
            return false;
          }
        }
        return true;
      });
    }
  }, [ssotUserData, filteredInfo, userData]);

  useEffect(() => {
    fetchUserData();
  }, []);

  const reportingManagersFilter = newFiltersData.find(
    (filter) => filter.filter_code === "reporting_manager"
  );

  const sortedReportingManagers = reportingManagersFilter?.filter_values
    .slice()
    .sort((a, b) => a.value.localeCompare(b.value));

  const reportingManagersOptions = sortedReportingManagers?.map((item) => (
    <option key={item.code} value={item.code}>
      {item.value}
    </option>
  ));

  const getChangedFields = () => {
    const changedFields = {};
    for (const key in formData) {
      if (formData[key] !== initialFormDataRef.current[key]) {
        changedFields[key] = formData[key];
      }
    }
    return changedFields;
  };

  const handleSave = () => {
    const payload = getChangedFields();
    payload.doj = formData.doj ?? currentUser.doj;
    payload.userId = selectedUser.id;

    if (selectedQa.id) {
      payload["qa"] = { qaUserId: selectedQa.id, flag: selectedQa.flag };
    }
    fetchEditSSOT(payload);
    setTriggerFetch(true);
    setModalShow(false);
    setSelectedUser(null);
    clearQaStates();
  };

  useEffect(() => {
    setSsotUserData(newFiltersApplyData.result);
  }, [newFiltersApplyData.result]);

  const transformReportingManagerFilter = (filters, newFiltersData) => {
    const reportingManagerValue = filters.reporting_manager;

    if (reportingManagerValue) {
      const reportingManagerFilter = newFiltersData.find(
        (filter) => filter.filter_code === "reporting_manager"
      );

      if (reportingManagerFilter) {
        if (Array.isArray(reportingManagerValue)) {
          filters.reporting_manager = reportingManagerValue.map((value) => {
            const matchingValue = reportingManagerFilter.filter_values.find(
              (item) => item.value === value
            );
            return matchingValue ? matchingValue.code : value;
          });
        } else {
          const matchingValue = reportingManagerFilter.filter_values.find(
            (item) => item.value === reportingManagerValue
          );
          if (matchingValue) {
            filters.reporting_manager = matchingValue.code;
          }
        }
      }
    }

    return filters;
  };

  const handleApplyFilters = (filters) => {
    let updatedFilters = { ...filters };

    if (
      updatedFilters.reporting_manager &&
      updatedFilters.reporting_manager.length > 0
    ) {
      updatedFilters = transformReportingManagerFilter(
        updatedFilters,
        newFiltersData
      );
    }

    const mergedFilters = {
      ...queryParam,
      ...updatedFilters,
      pageSize: 10,
      pageNumber: 1,
    };

    const finalFilters = filterAndTransformParams(mergedFilters);
    setQueryParam(finalFilters);
    setTriggerFetch(true);
    setCurrentPage(1);
    setPageSize(10);
    setVisible(!visible);
  };

  useEffect(() => {
    if (modalShow && isEmpty(qaAgentsResponse)) {
      (async () => {
        await getQaAgentsList();
      })();
    }
  }, [modalShow]);

  function checkUserIsQa(user = {}) {
    return get(user, "team") === "Quality" &&
      get(user, "desgination") === "Quality Analyst"
      ? true
      : false;
  }
  return (
    <CardDiv
      title={"SSOT"}
      component={
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: 10,
            }}
          >
            <Button
              type="primary"
              onClick={downloadCSV}
              disabled={[ROLES_NAME.SUPER_ADMIN].includes(roles[secureLocalStorage?.getItem("role")]) ? false : isDownloadDisabled}
              style={{ marginRight: 10 }}
            >
              Download
            </Button>
            <Button
              type="primary"
              onClick={() => setVisible(true)}
              shape="round"
              style={{ marginRight: 10 }}
            >
              Filter
            </Button>
            <Drawer
              title="Filter for SSOT"
              placement="right"
              onClose={() => setVisible(false)}
              visible={visible}
              width="30%"
              zIndex={999999999}
            >
              <SSOTFilter
                newfiltersData={newFiltersData}
                onApplyFilters={handleApplyFilters}
                onClose={() => setVisible(!visible)}
                setSsotUserData={setSsotUserData}
                setQueryParam={setQueryParam}
                queryParam={queryParam}
                setCurrentPage={setCurrentPage}
                setPageSize={setPageSize}
                setTriggerFetch={setTriggerFetch}
              />
            </Drawer>
            <span className="shadow p-2 text-nowrap text-center">
              Results: {newFiltersApplyData.total}
            </span>{" "}
          </div>
          <Modal
            show={modalShow}
            onHide={() => setModalShow(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                Edit Details
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {selectedUser !== null && (
                <form>
                  <div className="row mb-3">
                    <div className="col">
                      <label htmlFor="call_provider" className="form-label">
                        Call Provider
                      </label>
                      <Select
                        style={{ display: "block" }}
                        id="call_provider"
                        name="callProvider"
                        defaultValue={selectedUser.call_provider}
                        onChange={(value) =>
                          handleInputChange({
                            target: { name: "callProvider", value },
                          })
                        }
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        placeholder="Please select Call Provider"
                      >
                        <Select.Option value="Voitek">Voitek</Select.Option>
                        <Select.Option value="Exotel">Exotel</Select.Option>
                        <Select.Option value="Knowlarity">
                          Knowlarity
                        </Select.Option>
                        <Select.Option value="Own provier">
                          Own provier
                        </Select.Option>
                        <Select.Option value="NA">
                          NA
                        </Select.Option>

                      </Select>
                    </div>
                    <div className="col">
                      <label htmlFor="house" className="form-label">
                        House
                      </label>
                      <Select
                        style={{ display: "block" }}
                        id="house"
                        name="house"
                        defaultValue={selectedUser.house}
                        onChange={(value) =>
                          handleInputChange({
                            target: { name: "house", value },
                          })
                        }
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        placeholder="Please select House"
                      >
                        <Select.Option value="In-house">In-house</Select.Option>
                        <Select.Option value="Outsource">
                          Outsource
                        </Select.Option>
                      </Select>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col">
                      <label htmlFor="employee_id" className="form-label">
                        Employee Id
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="employee_id"
                        name="employeeId"
                        value={formData.employeeId}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="col">
                      <label htmlFor="location" className="form-label">
                        Location
                      </label>
                      <Select
                        style={{ display: "block" }}
                        id="location"
                        name="location"
                        defaultValue={selectedUser.location}
                        onChange={(value) =>
                          handleInputChange({
                            target: { name: "location", value },
                          })
                        }
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        placeholder="Please select Location"
                      >
                        {locationFilters.map((value) => (
                          <Select.Option key={value} value={value}>
                            {value}
                          </Select.Option>
                        ))}
                        <Select.Option value="">
                          NA
                        </Select.Option>
                      </Select>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col">
                      <label htmlFor="reporting_manager" className="form-label">
                        Reporting Manager
                      </label>
                      <Select
                        style={{ display: "block" }}
                        id="reporting_manager"
                        name="reportingManager"
                        defaultValue={selectedUser.reporting_manager}
                        onChange={(value) =>
                          handleInputChange({
                            target: { name: "reportingManager", value },
                          })
                        }
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        placeholder="Please select Reporting Manager"
                      >
                        {reportingManagersOptions}
                        <Select.Option value="">
                          NA
                        </Select.Option>
                      </Select>
                    </div>
                    <div className="col">
                      <label htmlFor="desgination" className="form-label">
                        Designation
                      </label>
                      <Select
                        style={{ display: "block" }}
                        id="desgination"
                        name="desgination"
                        defaultValue={selectedUser.desgination}
                        onChange={(value) =>
                          handleInputChange({
                            target: { name: "desgination", value },
                          })
                        }
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        placeholder="Please select Designation"
                      >
                        {designationFilter.map((desg) => (
                          <Select.Option key={desg} value={desg}>
                            {desg}
                          </Select.Option>
                        ))}
                        <Select.Option value="">
                          NA
                        </Select.Option>
                      </Select>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col">
                      <label htmlFor="process" className="form-label">
                        Process
                      </label>
                      <Select
                        style={{ display: "block" }}
                        id="process"
                        name="process"
                        defaultValue={selectedUser.process}
                        onChange={(value) =>
                          handleInputChange({ target: { name: "process", value } })
                        }
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        placeholder="Please select Process"
                      >
                        {Process.map((value) => (
                          <Select.Option key={value} value={value}>
                            {value}
                          </Select.Option>
                        ))}
                        <Select.Option value="">
                          NA
                        </Select.Option>
                      </Select>
                    </div>
                    <div className="col">
                      <label htmlFor="team" className="form-label">
                        Team
                      </label>
                      <Select
                        style={{ display: "block" }}
                        id="team"
                        name="team"
                        defaultValue={selectedUser.team}
                        onChange={(value) =>
                          handleInputChange({ target: { name: "team", value } })
                        }
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        placeholder="Please select Team"
                      >
                        {Teams.map((teams) => (
                          <Select.Option key={teams.value} value={teams.value}>
                            {teams.value}
                          </Select.Option>
                        ))}
                        <Select.Option value="">
                          NA
                        </Select.Option>
                      </Select>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col">
                      <label htmlFor="week_off" className="form-label">
                        Week Off
                      </label>
                      <Select
                        style={{ display: "block" }}
                        id="week_off"
                        name="weekOff"
                        defaultValue={selectedUser.week_off}
                        onChange={(value) =>
                          handleInputChange({ target: { name: "weekOff", value } })
                        }
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        placeholder="Please select the Week Off"
                      >
                        <Select.Option value="Mon">Mon</Select.Option>
                        <Select.Option value="Tue">Tue</Select.Option>
                        <Select.Option value="Wed">Wed</Select.Option>
                        <Select.Option value="Thu">Thu</Select.Option>
                        <Select.Option value="Fri">Fri</Select.Option>
                        <Select.Option value="Sat">Sat</Select.Option>
                        <Select.Option value="Sun">Sun</Select.Option>
                        <Select.Option value="Rotational">
                          Rotational
                        </Select.Option>
                        <Select.Option value="">
                          NA
                        </Select.Option>
                      </Select>
                    </div>
                    <div className="col">
                      <label htmlFor="shift" className="form-label">
                        Shift
                      </label>
                      <Select
                        style={{ display: "block" }}
                        id="shift"
                        name="shift"
                        defaultValue={selectedUser.shift}
                        onChange={(value) =>
                          handleInputChange({ target: { name: "shift", value } })
                        }
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        placeholder="Please select the Shift timings"
                      >
                        <Select.Option value="10:00-19:00">
                          10:00-19:00
                        </Select.Option>
                        <Select.Option value="10:00-19:30">
                          10:00-19:30
                        </Select.Option>
                        <Select.Option value="11:30-21:00">
                          11:30-21:00
                        </Select.Option>
                      </Select>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-6">
                      <label htmlFor="doj" className="form-label">
                        DOJ
                      </label>
                      <ReactDatePicker
                        selected={
                          formData.doj ? new Date(formData.doj) : null
                        }
                        onChange={(newDate) => {
                          setFormData((prev) => ({
                            ...prev,
                            doj: newDate ? newDate.toISOString() : "",
                          }));
                        }}
                        className="form-control"
                        placeholderText="Select Date"
                        dateFormat="dd-MM-yyyy"
                        locale="es"
                      />
                    </div>
                    {!checkUserIsQa(selectedUser) ? (
                      <div className="col">
                        <label htmlFor="myQa" className="form-label">
                          My QA
                        </label>
                        <Select
                          style={{ display: "block" }}
                          id="myQa"
                          name="myQa"
                          showSearch
                          allowClear={true}
                          filterOption={(input, option) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                          }
                          defaultValue={myQa.id}
                          options={
                            Array.isArray(qaAgentsResponse) &&
                            qaAgentsResponse
                              .map((val) => ({
                                label: getFullName(val),
                                value: val.id,
                                key: `${val.id}`,
                              }))
                          }
                          placeholder={`Select`}
                          onChange={(value) => {
                            if (isEmpty(myQa.id)) {
                              // Existing QA is not exist ADD
                              setSelectedQa({
                                id: value,
                                flag: MUTATION_FLAGS.ADD,
                              });
                            } else if (!isEmpty(value) && myQa.id !== value) {
                              // Existing QA is present and id is not match Update
                              setSelectedQa({
                                id: value,
                                flag: MUTATION_FLAGS.UPDATE,
                              });
                            } else if (
                              !isEmpty(myQa.id) &&
                              value === undefined
                            ) {
                              // QA exists and value is undefined Clear Action Delete
                              setSelectedQa({
                                id: myQa.id,
                                flag: MUTATION_FLAGS.DELETE,
                              });
                            } else {
                              //Missing Condition
                              setSelectedQa({
                                id: null,
                                flag: null,
                              });
                            }
                          }}
                        >
                          <Select.Option value="">
                            NA
                          </Select.Option>
                        </Select>
                      </div>
                    ) : null}
                  </div>
                  <div className="row mb-3">
                    <div className="col">
                      <label htmlFor="language" className="form-label">
                        Regional Language
                      </label>
                      <Select
                        mode="single"
                        style={{ display: "block" }}
                        id="language"
                        name="language"
                        defaultValue={selectedUser.preferred_language}
                        onChange={handleLanguageChange}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children.toLowerCase().includes(input.toLowerCase())
                        }
                        placeholder="Please select Languages"
                      >
                        {Object.entries(AGENT_LANGUAGES).map(([key, language]) => {
                          return (
                            <Select.Option key={key} value={key}>
                              {language}
                            </Select.Option>
                          );
                        })}

                        {/* <Select.Option value="English">English</Select.Option>
                        <Select.Option value="Spanish">Spanish</Select.Option>
                        <Select.Option value="French">French</Select.Option> */}
                        {/* Add more language options as needed */}
                      </Select>
                    </div>
                  </div>
                </form>
              )}
            </Modal.Body>

            <Modal.Footer>
              <Button disabled={Object.keys(getChangedFields())?.length === 0 && (selectedQa?.id === null || selectedQa?.flag === null)} onClick={handleSave}>Save</Button>
              <Button onClick={() => setModalShow(false)}>Close</Button>
            </Modal.Footer>
          </Modal>
          <div className="table-responsive">
            <Table
              columns={columns}
              dataSource={ssotUserData}
              onChange={handleTableChange}
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: newFiltersApplyData.total,
                showSizeChanger: true,
              }}
              filteredInfo={filteredInfo}
              scroll={{ x: "max-content" }}
              loading={qaAgentsLoading}
            />
          </div>
        </>
      }
    />
  );
};

export default SSOT;